import React from 'react';
import { theme } from 'antd';
import useTenantFlags from 'hooks/useTenantFlags';

const { useToken } = theme;

// Anillo de % "al día" (mantención / cumplimiento), portado del Diseño 2
// (screens/clientes.html). Verde >= threshold, ámbar por debajo.
// - score: número 0-100 (si es undefined/null → estado "sin datos").
// - threshold: umbral verde/ámbar (default 95, igual que el diseño).
// - label: texto bajo el porcentaje (default "al día").
function HealthRing({ score, threshold = 95, label = 'al día', size = 30 }) {
  const { minvuEnabled } = useTenantFlags();
  const { token } = useToken();
  const hasScore = typeof score === 'number' && Number.isFinite(score);

  if (!minvuEnabled) return null;

  const r = size / 2 - 3;
  const c = 2 * Math.PI * r;
  const pct = hasScore ? Math.max(0, Math.min(100, score)) : 0;
  const offset = c * (1 - pct / 100);
  const ok = pct >= threshold;
  const tone = ok ? token.colorSuccess : token.colorWarning;

  if (!hasScore) {
    return <span style={{ color: token.colorTextQuaternary, fontSize: 12.5 }}>—</span>;
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span style={{ position: 'relative', width: size, height: size, flex: '0 0 auto' }}>
        <svg width={size} height={size} style={{ transform: 'rotate(-90deg)', display: 'block' }}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            stroke={token.colorFillSecondary}
            strokeWidth="3"
            fill="none"
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            stroke={tone}
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={offset}
          />
        </svg>
      </span>
      <span style={{ lineHeight: 1.1 }}>
        <span
          style={{
            fontFamily: token.fontFamilyCode,
            fontWeight: 600,
            fontSize: 13,
            color: tone,
          }}
        >
          {pct}%
        </span>{' '}
        <span style={{ fontSize: 11, color: token.colorTextQuaternary }}>{label}</span>
      </span>
    </span>
  );
}

export default HealthRing;
